import { isEqual } from 'lodash';

export class FilterService<TFilter> {
  getNonGridFilters(filters: TFilter, gridFilterKeys: string[]): Record<string, string> {
    const result: Record<string, string> = {};
    Object.entries(filters as {}).forEach(([key, value]) => {
      if (!gridFilterKeys.includes(key)) {
        result[key] = value as string;
      }
    });

    return result;
  }

  isEqual(left: TFilter, right: TFilter): boolean {
    const leftFilters = Object.entries(left as {}).reduce<Record<string, {} | null>>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = value;
        }

        return acc;
      },
      {} as Record<string, string>,
    );

    const rightFilters = Object.entries(right as {}).reduce<Record<string, {} | null>>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = value;
        }

        return acc;
      },
      {} as Record<string, string>,
    );

    return isEqual(leftFilters, rightFilters);
  }
}
